var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    fill: "none",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.832 19.396s6.563-8.604 15.605-8.604c9.041 0 15.604 8.604 15.604 8.604h18.083L35.437 2.187 1.748 19.396s25.813 13.562 39.375 22.896c9.917 6.854 9.917 10.208 9.917 10.208s-6.563 8.604-15.604 8.604c-9.042 0-15.605-8.604-15.605-8.604H1.75l33.688 17.208L69.27 52.5s-26.396-14-39.959-23.188c-10.791-7.145-9.479-9.916-9.479-9.916z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.187 21.875l-15.75 19.542L1.748 21.875v28.146h18.083v-14l15.605 9.187 15.75-19.687v14.291l18.083 9.771V21.875H51.187z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8e7bdd421a362db471686bae1c904bbe.svg";
export { ForwardRef as ReactComponent };